/**
 * Payment mode detection — Single Source of Truth (frontend)
 *
 * LIVE mode = production domain only:
 *   - authoritylayer.app
 *   - www.authoritylayer.app
 *
 * Everything else (preview, *.lovable.app, *.lovableproject.com, localhost)
 * runs in TEST mode. Test mode MUST NEVER:
 *   - charge a real card
 *   - send a live affiliate conversion
 *
 * Mirrored server-side in each edge function via `detectPaymentMode(req)`.
 */

export type PaymentMode = "live" | "test";

const LIVE_HOSTS = new Set<string>([
  "authoritylayer.app",
  "www.authoritylayer.app",
]);

export function detectPaymentMode(): PaymentMode {
  if (typeof window === "undefined") return "test";
  const host = window.location.hostname.toLowerCase();
  return LIVE_HOSTS.has(host) ? "live" : "test";
}

export const PAYMENT_MODE: PaymentMode = detectPaymentMode();

export const IS_LIVE_PAYMENT_MODE = PAYMENT_MODE === "live";
export const IS_TEST_PAYMENT_MODE = PAYMENT_MODE === "test";

// Loud, hard-to-miss console banner so future debugging cannot confuse
// the two environments.
let __bannerLogged = false;
export function logPaymentModeBanner(): void {
  if (__bannerLogged || typeof window === "undefined") return;
  __bannerLogged = true;
  if (IS_LIVE_PAYMENT_MODE) {
    // eslint-disable-next-line no-console
    console.log(
      "%c💳 PAYMENTS: LIVE MODE 💳",
      "background:#7f1d1d;color:#fff;font-size:14px;font-weight:700;padding:6px 12px;border-radius:4px",
      `host=${window.location.hostname}`,
    );
  } else {
    // eslint-disable-next-line no-console
    console.log(
      "%c🧪 PAYMENTS: TEST MODE — no real charges, no live conversions 🧪",
      "background:#F2A000;color:#0f1318;font-size:14px;font-weight:700;padding:6px 12px;border-radius:4px",
      `host=${window.location.hostname}`,
    );
  }
}
